import { Projection } from "../../common/EasyProjection/types";
import { Constants } from "./constants";
import { Lineup, LineupRubric } from "./types";

export const createLineup = (lineup: Lineup) => ({
  type: Constants.CREATE_LINEUP,
  payload: lineup,
})

export const setSelectedLineup = (lineupId: number | null) => ({
  type: Constants.SELECT_LINEUP,
  payload: lineupId,
})

export const addPlayer = (player: Projection, lineupId: number, site: string) => ({
  type: Constants.ADD_PLAYER,
  payload: {player, lineupId, site},
})
export const setLineup = (players: Projection[], lineupId: number) => ({
  type: Constants.SET_LINEUP,
  payload: { players, lineupId },
})
export const removePlayer = (player: Projection | LineupRubric, lineupId: number) => ({
  type: Constants.REMOVE_PLAYER,
  payload: {player, lineupId},
})

export const setSelectedMatchups = (matchups: string[]) => ({
  type: Constants.SET_SELECTED_MATCHUPS,
  payload: matchups,
})

export const setCsvHeaders = (headers: string) => ({
  type: Constants.SET_CSV_HEADERS,
  payload: headers,
})

export const setPoolSize = (poolSize: number) => ({
  type: Constants.SET_POOL_SIZE,
  payload: poolSize,
})

export const setPercentChange = (percentToFirst: number) => ({
  type: Constants.SET_PERCENT_TO_FIRST,
  payload: percentToFirst,
})

export const setLineupChecked = (lineupId: number, validatedRes: { isValid: boolean, errorMessage: string}) => ({
  type: Constants.SET_LINEUP_CHECKED,
  payload: {lineupId, ...validatedRes},
})

export const setLineupRules = (rules: string[]) => ({
  type: Constants.SET_LINEUP_RUBRIC,
  payload: rules
})

export const setSimResults = (results: { lineupId: number, simStatus: 'loading' | 'complete' | 'error' | 'incomplete', simResults: any }) => ({
  type: Constants.SET_SIM_RESULTS,
  payload: results
})

export const setProjectionsRedux = (projections: Projection[]) => ({
  type: Constants.SET_PROJECTIONS,
  payload: projections
})

// Every player on the selected slate, whatever the matchup filter shows.
export const setSlateProjections = (projections: Projection[]) => ({
  type: Constants.SET_SLATE_PROJECTIONS,
  payload: projections
})

export const resetLineup = (lineupId: number) => ({
  type: Constants.RESET_LINEUP,
  payload: {lineupId}
})

export const setSavedLineups = (lineups: Lineup[], projections: Projection[] = []) => ({
  type: Constants.SET_SAVED_LINEUPS,
  payload: lineups,
  projections,
})

export const deleteLineup = (lineupId: number) => ({
  type: Constants.DELETE_LINEUP,
  payload: lineupId
})
export const deleteAllLineups = () => ({
  type: Constants.DELETE_ALL_LINEUPS,
})

export const togglePlayerLock = (playerNameAndId: string, lineupId: number) => ({
  type: Constants.TOGGLE_PLAYER_LOCK,
  payload: { playerNameAndId, lineupId }
})

export const setLineupRandomness = (lineupId: number, randomness: number) => ({
  type: Constants.SET_LINEUP_RANDOMNESS,
  payload: { lineupId, randomness }
})

export const setDefaultRandomness = (randomness: number) => ({
  type: Constants.SET_DEFAULT_RANDOMNESS,
  payload: randomness
})
